/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createNumber } from '../../factoriesNumber.js';
export var numberDependencies = {
  typedDependencies,
  createNumber
};